module.exports = __webpack_public_path__ + "static/media/haarentfernung.148c2bc9.jpg";